import { useMemo } from 'react';
import { TerminalLines } from './TerminalLines.js';
import type { TermLine } from '../../hooks/useTypewriter.js';

const IDENTIFY_LINE_ID = 't3';

/**
 * רצף הקבלה של משימה חדשה בתוך הטרמינל (סעיף 6/15).
 * אין מעטפה פיזית ואין אנימציית מעטפה — הכול טקסט מסוף.
 *
 * onIdentified נקרא בדיוק ברגע שהשורה "> {agentLabel} זוהה." מסיימת להקליד —
 * זה הרגע שבו פאנל זיהוי הסוכנים עובר מ"סורק" ל"מזוהה" (לבקשת המשתמש).
 */
export function TransmissionAnimation({
  agentLabel,
  animationsEnabled,
  onDone,
  onIdentified,
}: {
  agentLabel: string;
  animationsEnabled: boolean;
  onDone: () => void;
  onIdentified?: () => void;
}) {
  // הטקסט המלא המקורי (לבקשת המשתמש), בהקלדה מהירה יותר וממתינות קצרות.
  // מוצג רק בפתיחה חדשה שעוד לא הוצגה במכשיר הזה.
  const lines = useMemo<TermLine[]>(
    () => [
      { id: 't1', text: '> מתחבר למערכת מאובטחת...', variant: 'system', pauseAfterMs: 90 },
      { id: 't2', text: '> מאמת זהות...', variant: 'system', pauseAfterMs: 90 },
      { id: IDENTIFY_LINE_ID, text: `> ${agentLabel} זוהה.`, variant: 'ok', pauseAfterMs: 110 },
      { id: 't4', text: '> מתקבלת העברה חדשה...', variant: 'system', pauseAfterMs: 100 },
      { id: 't5', text: '> TRANSMISSION RECEIVED', variant: 'amber', pauseAfterMs: 110 },
      { id: 't6', text: '> DECRYPTING...', variant: 'amber', pauseAfterMs: 130 },
      { id: 't7', text: '> פענוח נתונים...', variant: 'system', pauseAfterMs: 110 },
      { id: 't8', text: '> ACCESS GRANTED', variant: 'ok', pauseAfterMs: 160 },
    ],
    [agentLabel],
  );
  return (
    <div className="term-panel" style={{ padding: 'var(--space-4)' }}>
      <TerminalLines
        lines={lines}
        animationsEnabled={animationsEnabled}
        onDone={onDone}
        onLineComplete={(line) => {
          if (line.id === IDENTIFY_LINE_ID) onIdentified?.();
        }}
        showCursorAtEnd={false}
      />
    </div>
  );
}
